import dayjs from "dayjs";

export const getEstimatedTurnaroundDate = (dateAdviserInformed) => {
  const informedDate = dayjs(dateAdviserInformed);
  const timelineStart = informedDate.isValid() ? informedDate : dayjs();

  return timelineStart.add(3, "month").format("YYYY-MM-DD");
};

export const getWebsiteEstimatedTurnaroundDate = (website) =>
  String(website?.estimatedTurnaroundDate || "").trim() ||
  getEstimatedTurnaroundDate(website?.dateAdviserInformed);

export const isWebsiteOverdue = (website, today = dayjs()) => {
  const status = String(website?.status || "").trim().toLowerCase();
  if (["live", "npw", "npm", "on hold"].includes(status)) {
    return false;
  }

  const deadline = dayjs(getWebsiteEstimatedTurnaroundDate(website));
  return deadline.isValid() && today.startOf("day").isAfter(deadline.startOf("day"));
};

export const isWebsiteTimelineExtended = (website) => {
  const status = String(website?.status || "").trim().toLowerCase();
  if (["get in contact", "live", "npw", "npm", "on hold"].includes(status)) return false;

  const informedDate = dayjs(website?.dateAdviserInformed);
  const estimatedDate = dayjs(website?.estimatedTurnaroundDate);
  return (
    informedDate.isValid() &&
    estimatedDate.isValid() &&
    estimatedDate.isAfter(informedDate.add(3, "month"), "day")
  );
};
